var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "80px",
    viewBox: "0 0 110 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1--E-mail-templates-customization",
    transform: "translate(-1175.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(721.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(277.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-3",
    transform: "translate(29.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(0.000000, 9.742857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.803279,48.9102402 C101.803279,21.8983373 80.004209,0 53.1147541,0 C26.2252992,0 4.42622951,21.8983373 4.42622951,48.9102402 C4.42622951,56.107382 5.98669672,62.9340288 8.76437705,69.0857143 L97.4651311,69.0857143 C100.242811,62.9340288 101.803279,56.107382 101.803279,48.9102402",
    id: "Fill-1",
    fill: "#B0BAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,69.0857143 L2.6557377,69.0857143",
    id: "Stroke-5",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688525,69.0857143 L105.344262,69.0857143",
    id: "Stroke-7",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31147541,69.0857143 L100.032787,69.0857143",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.786885, 9.742857)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#333333",
    x: 7.08196721,
    y: 14.1714286,
    width: 42.4918033,
    height: 25.6857143,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6557377,5.39205233 C56.6557377,2.41330083 54.240812,0 51.2600548,0 L5.39568287,0 C2.41706094,0 0,2.41330083 0,5.39205233 L0,47.1820582 C0,50.1586759 2.41492573,52.5741105 5.39568287,52.5741105 L15.2945296,52.5741105 C16.5329531,52.5741105 17.5365031,53.5769853 17.5365031,54.8145755 L17.5365031,60.6461857 C17.5365031,61.5509068 18.0831176,62.3681431 18.920121,62.7159486 C19.7592597,63.0616203 20.7222407,62.8695805 21.3628045,62.2294476 L30.3691323,53.2291798 C30.7897693,52.8109597 31.3598711,52.5741105 31.9534603,52.5741105 L51.2600548,52.5741105 C54.240812,52.5741105 56.6557377,50.1586759 56.6557377,47.1820582 L56.6557377,5.39205233 Z",
    id: "Stroke-5",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4164715,15.0571429 L10.2371194,15.0571429 C9.70472287,15.0571429 9.23887588,15.2542909 8.85245902,15.5390604 L26.0072209,25.0897894 C27.4348165,25.8843559 29.2187744,25.8843559 30.64637,25.0897894 L47.8032787,15.5390604 C47.4168618,15.2522995 46.9488681,15.0571429 46.4164715,15.0571429 Z",
    id: "Stroke-94",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5399829,38.9714286 L10.1157548,38.9714286 C8.92975981,38.9714286 7.96721311,38.0293252 7.96721311,36.8685192 L7.96721311,17.1600523 C7.96721311,15.9992463 8.92975981,15.0571429 10.1157548,15.0571429 L46.5399829,15.0571429 C47.7259779,15.0571429 48.6885246,15.9992463 48.6885246,17.1600523 L48.6885246,36.8685192 C48.6885246,38.0293252 47.7259779,38.9714286 46.5399829,38.9714286 Z",
    id: "Stroke-95",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 19.485714)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60958219,5.27512782 L2.60958219,1.41220369e-13",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,2.63775504 L5.22067735,2.63775504",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(102.688525, 38.971429)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60958219,5.27512782 L2.60958219,1.41220369e-13",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,2.63775504 L5.22067735,2.63775504",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(88.524590, 62.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60958219,5.27512782 L2.60958219,1.41220369e-13",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,2.63775504 L5.22067735,2.63775504",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.508197, 49.600000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7704918,3.54285714 L1.7704918,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.77142857 L3.54098361,1.77142857",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(71.704918, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9.73770492,
    cy: 9.74285714,
    rx: 9.73770492,
    ry: 9.74285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14675599,10.8267618 L6.56047611,9.18657249 C6.32552414,8.90289314 5.95661456,8.77932645 5.60542125,8.86667579 C5.25422794,8.95402513 4.98002382,9.23754804 4.89554547,9.60067659 C4.81106711,9.96380515 4.93057243,10.3452521 5.20492786,10.5881888 L7.46417495,12.9341566 C7.64560579,13.1202302 7.89121785,13.22396 8.14675599,13.2224323 C8.39896476,13.2213343 8.64065563,13.1178023 8.81972321,12.9341566 L13.6266319,7.96388589 C13.8086336,7.77723572 13.911007,7.52315959 13.911007,7.25810744 C13.911007,6.99305529 13.8086336,6.73897916 13.6266319,6.55232899 C13.251657,6.16691074 12.6460585,6.16691074 12.2710837,6.55232899 L8.14675599,10.8267618 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/Illustration 3.b19dae28c53be0eb211cffdcc5cc220f.svg";
export { ForwardRef as ReactComponent };